import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_INVENTORY_HOSTS = "/infrastructure/hosts";
export const REDIRECT_TO_INVENTORY_INSTANCES = "/infrastructure/instances";
export const REDIRECT_TO_INVENTORY_DATABASES = "/infrastructure/databases";
export const REDIRECT_TO_INVENTORY_TABLES = "/infrastructure/tables/overview";
export const REDIRECT_TO_INVENTORY_TABLES_DETAIL = "/infrastructure/tables/detail";
export const REDIRECT_TO_RESOURCES = "/admin_console/collections/resources";

export const infrastructurePages = {
  id: "Infrastructure",
  label: "Infrastructure",
  icon: "spacesApp",
  items: [
    {
      label: "Hosts",
      path: "/infrastructure/hosts",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Infrastructure_Hosts,
        role: Roles.Read,
      },
    },
    {
      label: "Instances",
      path: "/infrastructure/instances",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Infrastructure_Instances,
        role: Roles.Read,
      },
    },
    {
      label: "Databases",
      path: "/infrastructure/databases",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Infrastructure_Databases,
        role: Roles.Read,
      },
    },
    {
      label: "Tables",
      path: "/infrastructure/tables/overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Host_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/infrastructure/tables/overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/infrastructure/tables/detail",
          requireClientSelection: true,
        },
      ],
    },
    {
      label: "Processes",
      path: "/infrastructure/processes/overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Host_Dashboards,
        role: Roles.Read,
      },
      topNavLinks: [
        {
          label: "Overview",
          path: "/infrastructure/processes/overview",
          requireClientSelection: true,
        },
        {
          label: "Details",
          path: "/infrastructure/processes/detail",
          requireClientSelection: true,
        },
      ],
    },
  ],
};
